import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { ROUTES } from '@/config/routes'
import { CheckCircle2 } from 'lucide-react'

export const ContactSentPage = () => {
  return (
    <div className="container max-w-2xl mx-auto py-16">
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="h-6 w-6 text-green-600" />
            <CardTitle>Message Sent Successfully</CardTitle>
          </div>
          <CardDescription>We've received your message and will respond shortly</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="rounded-md bg-green-50 p-4 text-sm text-green-800">
            Thank you for contacting us! Your message has been successfully submitted to our support team.
            <br /><br />
            We typically respond to inquiries within 1-2 business days. If your matter is urgent,
            please call us at 1-800-PULSE-WIN.
            <br /><br />
            A confirmation email has been sent to the address you provided.
          </div>
        </CardContent>
        <CardFooter className="flex gap-2">
          <Button asChild>
            <Link to={ROUTES.DASHBOARD}>
              Return to Dashboard
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/contact">
              Send Another Message
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
